import React from "react";
import {
  Mail,
  MapPin,
  Phone,
  Linkedin,
  Instagram,
  Facebook,
  X,
} from "lucide-react";
import "./footer.css";
import logo from "../images/Eaekanem-logo.jpg";
import award from "../images/42828-removebg-preview.png";
import { Link } from "react-router-dom";
import { BsFillThreadsFill } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Quick Links */}
        <div className="footer-section">
          <h3>QUICK LINKS</h3>
          <ul>
            <li>
              <Link to="/">HOME</Link>
            </li>
            <li>
              <Link to="/about">ABOUT US</Link>
            </li>
            <li>
              <Link to="/our-listing">OUR LISTING</Link>
            </li>
            <li>
              <Link to="/our-business">OUR BUSINESS</Link>
            </li>
            <li>
              <Link to="/sell-with-us">SELL WITH US</Link>
            </li>
            <li>
              <Link to="/contact">CONTACT</Link>
            </li>
            <li>
              <Link to="/talentcommunity">JOIN OUR TALENT COMMUNITY</Link>
            </li>
            <li>
              <Link to="/giving-back">GIVING BACK</Link>
            </li>
          </ul>
        </div>

        {/* Center Logo & Social Icons */}
        <div className="footer-center">
          <img src={logo} alt="EAEkanem Consulting" className="footer-logo" />
          <img src={award} alt="Award" className="footer-medal" />

          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/in/eaekanemconsulting-estate-surveyors-and-valuers-6ba23b286/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin size={18} />
            </a>
            <a
              href="https://x.com/EA_Ekanem"
              target="_blank"
              rel="noopener noreferrer"
            >
              <X size={18} />
            </a>
            <a
              href="https://www.instagram.com/eaekanem_consulting/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://www.threads.com/@eaekanem_consulting"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Threads"
              className="threads-link"
            >
             <BsFillThreadsFill />
            </a>
            <a
              href="https://web.facebook.com/profile.php?id=100095212459873"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook size={18} />
            </a>
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>CONTACT INFO</h3>
          <ul>
            <li>
              <MapPin size={18} />
              <span>
                Suite 401b, Midel Centre, Oladipo Diya Way, Gudu, Abuja
              </span>
            </li>
            <li>
              <Mail size={18} />
              <a href="mailto:eaekanemconsulting.esv@gmail.com">
                eaekanemconsulting.esv@gmail.com
              </a>
            </li>
            <li>
              <Phone size={18} />
              <a href="tel:+2348085312366">+234 (0) 808 531 2366</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} eaekanemconsulting | Powered by{" "}
          <span>eaekanemconsulting</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
